import { useNavigate } from "react-router-dom";

const ProjectsOnNewPage = false;

function HeadLine() {
  const navigate = useNavigate();

  return (
    <div className="p-4 mx-auto w-full flex flex-col gap-8 justify-center items-center">
      <Introduction />

      <div className="flex flex-row gap-4">
        <a
          href="#projects"
          onClick={() => ProjectsOnNewPage && navigate("/projects")}
          className="flex bg-gray-50 cursor-pointer shrink-0 leading-1 px-4 py-2 text-md rounded-xl justify-around gap-3 transition hover:bg-slate-900/[0.03] items-center animate-fadeout"
        >
          <button>View Projects</button>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="size-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M2.25 12.75V12A2.25 2.25 0 0 1 4.5 9.75h15A2.25 2.25 0 0 1 21.75 12v.75m-8.69-6.44-2.12-2.12a1.5 1.5 0 0 0-1.061-.44H4.5A2.25 2.25 0 0 0 2.25 6v12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9a2.25 2.25 0 0 0-2.25-2.25h-5.379a1.5 1.5 0 0 1-1.06-.44Z"
            />
          </svg>
        </a>

        <a
          href="https://dinesh563.github.io/resume/Dinesh_resume.pdf"
          className="flex bg-gray-50 cursor-pointer shrink-0 leading-1 px-4 py-2 text-md rounded-xl justify-around gap-3 transition hover:bg-slate-900/[0.03] items-center animate-fadeout"
        >
          
          <span>Download CV</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="size-4"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"
            />
          </svg>
        </a>
      </div>
    </div>
  );
}

function Introduction() {
  const experience = getExperienceYears();

  const sentenceParts = [
    "Hi, I'm Dinesh —",
    "Senior Backend Developer",
    `with ${experience} years of experience building scalable systems and solving real-world problems through code.`,
  ];

  return (
    <span className="text-3xl w-full md:w-1/2 flex-wrap justify-center font-extrabold flex gap-2 flex-row">
      {sentenceParts[0].split(" ").map((word, index) => (
        <span
          key={`part0-${index}`}
          className="inline-block animate-fadeout"
          style={{ "--fadeout-duration": `${0.2 + index * 0.1}s` }}
        >
          {word}
        </span>
      ))}

      <span className="px-1 rounded-md bg-pink-500 text-white -skew-y-[0.8deg]">
        {sentenceParts[1].split(" ").map((word, index) => (
          <span
            key={`highlight-${index}`}
            className="inline-block animate-fadeout"
            style={{
              "--fadeout-duration": `${0.5 + index * 0.1}s`,
              marginRight: "0.25rem",
            }}
          >
            {word}
          </span>
        ))}
      </span>

      {sentenceParts[2].split(" ").map((word, index) => (
        <span
          key={`part2-${index}`}
          className="inline-block animate-fadeout"
          style={{ "--fadeout-duration": `${0.5 + index * 0.1}s` }}
        >
          {word}
        </span>
      ))}
    </span>
  );
}

function getExperienceYears() {
  const joiningDate = new Date("2021-12-06");
  const now = new Date();
  const diffInMs = now - joiningDate;
  const diffInYears = diffInMs / (1000 * 60 * 60 * 24 * 365.25); // accounting for leap years
  return diffInYears.toFixed(1); // returns 3.5, 4.0, etc.
}

export default HeadLine;
